<template>
    <CButton
        color="primary"
        class="ml-2 button shadow d-flex"
        @click="back"
    >
        <span class="button__icon text-white-50">
            <CIcon :content="$options.icons.cilArrowThickFromRight" />
        </span>
        <span class="button__text">
            {{ $t("back") }}
        </span>
    </CButton>
</template>

<script>
import { cilArrowThickFromRight } from "@coreui/icons";
export default {
    name: "ButtonBack",
    icons: {
        cilArrowThickFromRight,
    },
    data() {
        return {
            toComponent: () => {
                this.$router.go(-1);
            },
        };
    },
    props: {
        to: {
            type: Object | null,
            default: () => {
                return -1;
            },
        },
    },
    methods: {
        back() {
            if (this.to == -1) {
                this.$router.go(-1);
            } else {
                this.$router.push(this.to);
            }
        },
    }
};
</script>

<style>
</style>